<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <h4 class="page-title">{{ trainee_name }} Grade List</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <span v-if="trainee_grades.length > 0" class="badge badge-success mr-2">Total Search Data Found: {{ trainee_grades.length }}</span>
                        </div>
                        <div class="col-md-6">
                           <download-excel
                              class = "btn btn-light btn-sm float-right"
                              :data = "trainee_grades"
                              :fields = "trainee_grade_fields"
                              :meta="json_meta"
                              worksheet = "Trainee grade"
                              name = "trainee-grade.xls">
                            Download Excel
                          </download-excel>
                            <b-button
                                    v-b-modal.business-modal
                                    type="button" class="btn btn-success btn-sm mb-1  mr-2 float-right"
                                    @click="$bvModal.show('trainee-grade-modal'), resetForm()">
                                    Add Grade
                                <i class="fas fa-plus"></i>
                            </b-button>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>Exam</th>
                                <th>Exam Date</th>
                                <th>Mark</th>
                                <th>Grade</th>
                                <th>Remark</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(trainee_grade, index) in trainee_grades" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ trainee_grade.trainee_exam.title }}</td>
                                <td>{{ trainee_grade.trainee_exam.date }}</td>
                                <td>{{ trainee_grade.marks }}</td>
                                <td>{{ trainee_grade.grade }}</td>
                                <td>{{ trainee_grade.remarks }}</td>
                                <td>
                                    <a href="javascript:void(0);"
                                       class="action-icon" title="Edit marks details"
                                       @click.prevent="showGradeModal(trainee_grade), $bvModal.show('trainee-grade-modal')">
                                        <i class="mdi mdi-square-edit-outline editButton"></i>
                                    </a>
                                    <a href="javascript:void(0);"  class="action-icon" title="Delete marks"
                                       @click.prevent="onDelete(trainee_grade.id)">
                                        <i class="mdi mdi-delete-variant deleteButton"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 v-if="trainee_grades.length === 0"
                            class="text-center text-secondary">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
            <trainee-grade
                    :trainee_grade="trainee_grade"
                    :btn_edit="btn_edit"
                    @resetForm="resetForm"
                    @getTraineeGrade="getTraineeGrade"
            ></trainee-grade>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import TraineeGrade from "../../modals/TraineeGrade";

    export default {
        page: {
            title:  "Trainee Grade List",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {TraineeGrade, Layout, PageHeader },
        data() {
            return {
                title: "Trainee Grade List",
                items: [
                    {
                        text: "Grade",
                        href: "/"
                    },
                    {
                        text: "Dashboard",
                        active: true
                    }
                ],
                trainee_grades: [],
                trainee_grade: {},
                trainee_name: "",
                btn_edit: false,
                trainee_grade_fields: {
                    'Exam': 'trainee_exam.title',
                    'Exam Date': 'trainee_exam.date',
                    'Grade' : {
                        callback: (value) => {
                            return `${value.grade ? value.grade : "N/A"}`;
                        }
                    },
                    'Marks' : {
                        callback: (value) => {
                            return `${value.marks ? value.marks : "N/A"}`;
                        }
                    },
                    'Remarks' : {
                          callback: (value) => {
                              return `${value.remarks ? value.remarks : "N/A"}`;
                          }
                      },
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
            };
        },

        mounted() {
            this.traineeId = this.$route.params.trainee_id;
            this.getTraineeGrade(this.traineeId);
            this.getTraineeName(this.traineeId);
        },
        methods: {
            getTraineeGrade(traineeId) {
                http
                    .post("api/trainee/grade/list/" + traineeId)
                    .then(response => {
                        if (!response.error) {
                            this.trainee_grades = response.data.trainee_grades;
                        }
                    });
            },
            resetForm() {
                this.btn_edit = false;
                this.trainee_grade = {};
                this.trainee_grade.trainee_id = this.$route.params.trainee_id;
            },
            showGradeModal(trainee_grade) {
                this.trainee_grade = trainee_grade;
                this.btn_edit = true;
            },
            getTraineeName(traineeId) {
                http.get("api/getTraineeName/" + traineeId).then(response => {
                    this.trainee_name = response.data.trainee_name;
                });
            },
            onDelete(id) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/trainee/grades/" + id)
                        .then(response => {
                            if (response.data.permissionError) {
                                this.$bvToast.toast(response.data.permissionError, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            }else{
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                let traineeId = this.$route.params.trainee_id;
                                this.getTraineeGrade(traineeId);
                            }
                    });
                }
            },
        },
    };
</script>
